export default [
    {
        path: '/notification',
        name: 'notification',
        component: () => import('@/views/notification/index.vue'),
        meta: {
            layout: 'full',
        },
    },
]